import { getConfig } from "@cirrus/config"
import { NotificationsV1 } from "@cirrus/common/Notifications/v1"
import { Actions, Atom, Namespace } from "@cirrus/fe-lib"
import { keys, mergeRight, pick } from "ramda"

import { Customer } from "../_params.js"
import { L10n } from "../../../features/index.js"
import { CirrusApi } from "../../../shared/index.js"
import { Notifications } from "../../notifications/index.js"

import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

export const domain = Namespace.domain(Customer, "info")

const initialState = {
  defaultFormats: null,
  version: null,
  skinId: null,
  isDebugMode: false,
  homeUrl: null,
  saml: {},
  keycode: null,
  hideFormExtendedOptions: false,
  enableProctorIoIntegration: false,
  readSpeakerCustomerId: null,
  readSpeakerDocReaderId: null,
  readSpeakerLanguageSettings: [],
  readSpeakerRegion: null,
}

export const actions = Actions.of(Customer.domain, [
  "infoRequested",
  "infoFetched",
  "infoFetchFailed",
])

export const atom = Atom.behavior((on) => {
  on(actions.infoFetched, (state, payload) => mergeRight(state, pick(keys(initialState), payload)))
}, initialState)

const { showNotificationOn } = NotificationsV1.sagas

export const effects = [
  takeLatest(actions.infoRequested, function* () {
    try {
      const appConfig = getConfig()
      const { data } = yield call(CirrusApi.customer.customerInfoGET, appConfig.Customer)

      yield put(actions.infoFetched(data))
    } catch (error) {
      yield put(actions.infoFetchFailed(error))
    }
  }),

  takeEvery(actions.infoFetchFailed, function* ({ error }) {
    console.error(error)
  }),

  showNotificationOn(actions.infoFetchFailed, () => ({
    message: L10n.lib.string("Notification.Messages:ErrorOccurredDuringDataLoading"),
    type: Notifications.params.types.error,
  })),
]
